// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nextGenFeatureContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.nextGenImage {
  /* width: 3vw; */
  height: 3vw;
  /* margin-left: 1.83vw; */
}
.nextGenImage img {
  height: 90%;
  /* width: 90%; */
}
.nextGenHeading {
  /* margin-left: 1vw; */

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.31vw;
  line-height: 1.46vw;
  /* identical to box height, or 111% */

  color: #000000;

  margin-top: 1.24vw;
  margin-bottom: 1.09vw;
}
.nextGenDetail {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 1.09vw;
  line-height: 1.46vw;
  /* margin-left: 1.83vw; */

  /* or 133% */

  /* width: 60%; */
  color: #545454;
}
.nextGenFeaturesData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  /* width: 20%; */
  margin: 0 4.39vw;
  width: 24.81vw;
  height: 13vw;

  background: #ffffff;
  box-shadow: 0px 0.29vw 1.83vw rgba(0, 0, 0, 0.06);
  border-radius: 1.46vw;
}

.alignNextGen {
  /* align-items: center; */
  /* margin-bottom: 15px; */
  /* margin-top: -15px; */
  /* padding-top: -20px; */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/WebHomePage/Reusable/NextGenFeatures.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,sBAAsB;;EAEtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;;EAErC,cAAc;;EAEd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;;EAEzB,YAAY;;EAEZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,YAAY;;EAEZ,mBAAmB;EACnB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;AAC1B","sourcesContent":[".nextGenFeatureContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.nextGenImage {\n  /* width: 3vw; */\n  height: 3vw;\n  /* margin-left: 1.83vw; */\n}\n.nextGenImage img {\n  height: 90%;\n  /* width: 90%; */\n}\n.nextGenHeading {\n  /* margin-left: 1vw; */\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.31vw;\n  line-height: 1.46vw;\n  /* identical to box height, or 111% */\n\n  color: #000000;\n\n  margin-top: 1.24vw;\n  margin-bottom: 1.09vw;\n}\n.nextGenDetail {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1.09vw;\n  line-height: 1.46vw;\n  /* margin-left: 1.83vw; */\n\n  /* or 133% */\n\n  /* width: 60%; */\n  color: #545454;\n}\n.nextGenFeaturesData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* align-items: center; */\n  /* width: 20%; */\n  margin: 0 4.39vw;\n  width: 24.81vw;\n  height: 13vw;\n\n  background: #ffffff;\n  box-shadow: 0px 0.29vw 1.83vw rgba(0, 0, 0, 0.06);\n  border-radius: 1.46vw;\n}\n\n.alignNextGen {\n  /* align-items: center; */\n  /* margin-bottom: 15px; */\n  /* margin-top: -15px; */\n  /* padding-top: -20px; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
